import { useEffect, useMemo, useState } from 'react'

import DashboardCanvas from '../shared/components/DashboardCanvas'
import { useGetCompanyOptionsQuery, useGetPersonalDashboardQuery, useGetProjectOptionsQuery } from '../../../api/serverStateHooks'
import BridgeActionCenterModal from '../calendar/components/BridgeActionCenterModal'

function _todayString() {
  const d = new Date()
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export default function PersonalDashboardScreen() {
  const [selectedDate, setSelectedDate] = useState(_todayString)
  const [companyId, setCompanyId] = useState('')
  const [projectId, setProjectId] = useState('')
  const [isActionCenterOpen, setIsActionCenterOpen] = useState(false)

  const queryParams = useMemo(
    () => ({
      selected_date: selectedDate || undefined,
      company_id: companyId || undefined,
      project_id: projectId || undefined,
    }),
    [companyId, projectId, selectedDate],
  )

  const { data: backendView, isLoading, isError } = useGetPersonalDashboardQuery(queryParams)
  const { data: companies = [] } = useGetCompanyOptionsQuery({ page: 1, page_size: 200 })
  const { data: projects = [] } = useGetProjectOptionsQuery({ page: 1, page_size: 200 })
  const filteredProjects = companyId
    ? projects.filter((item) => String(item.companyId || '') === String(companyId))
    : projects

  useEffect(() => {
    if (!companyId) return
    const isValid = companies.some((item) => String(item.id) === String(companyId))
    if (!isValid) {
      setCompanyId('')
      setProjectId('')
    }
  }, [companyId, companies])

  useEffect(() => {
    if (!projectId) return
    const isValid = projects.some((item) => String(item.id) === String(projectId))
    if (!isValid) {
      setProjectId('')
    }
  }, [projectId, projects])

  if (isError && !backendView) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center p-20 text-error">
        <span className="material-symbols-outlined mb-2 text-5xl">error</span>
        <p className="font-bold">Failed to load dashboard data.</p>
      </div>
    )
  }

  return (
    <>
      <DashboardCanvas
        view={backendView}
        filters={{ selectedDate, companyId, projectId }}
        options={{ companies, projects: filteredProjects }}
        onDateChange={setSelectedDate}
        onCompanyChange={(value) => {
          setCompanyId(value)
          if (!value) return
          const selectedProject = projects.find((item) => String(item.id) === String(projectId))
          if (selectedProject && String(selectedProject.companyId || '') !== String(value)) {
            setProjectId('')
          }
        }}
        onProjectChange={setProjectId}
        onOpenActionCenter={() => setIsActionCenterOpen(true)}
      />

      <BridgeActionCenterModal
        isOpen={isActionCenterOpen}
        onClose={() => setIsActionCenterOpen(false)}
        defaultDate={selectedDate || new Date()}
        onCreated={() => setIsActionCenterOpen(false)}
      />
    </>
  )
}
